<template>
    <q-page padding>
        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab slot="title" name="trails" :label="$t(title_trails)" icon="fal fa-sign" />

            <q-tab-pane name="trails" class="q-px-md q-pb-xl q-mt-md">
                <div class="row gutter-sm">
                    <div :class="filterClass">
                        <filter-trail />
                    </div>

                    <div :class="contentClass">
                        <div class="row gutter-md">
                            <div class="col-12 desktop-only" v-if="banners.length > 0">
                                <q-carousel class="text-white" height="200px" infinite autoplay>
                                    <q-carousel-slide :img-src="banner.image_desktop" v-for="(banner, index) in banners" :key="index" />
                                </q-carousel>
                            </div>

                            <div class="col-12 mobile-only" v-if="banners.length > 0 && showBanner">
                                <q-carousel class="text-white" :height="`${getHeight}px`" infinite autoplay>
                                    <q-carousel-slide :img-src="banner.image_mobile" v-for="(banner, index) in banners" :key="index" />
                                </q-carousel>
                            </div>

                            <div class="col-12">
                                <div class="row gutter-md">
                                    <div class="col-xs-12 col-sm-12" v-for="(trail, index) in filteredTrails" :key="index">
                                        <card-trail-desktop :trail="trail" :key="trail.id" v-if="$q.platform.is.desktop" @clickLike="clickLike" @clickStars="clickStars" @clickFavorite="clickFavorite" />

                                        <card-trail-mobile :trail="trail" :key="trail.id" v-if="$q.platform.is.mobile" @clickLike="clickLike" @clickStars="clickStars" @clickFavorite="clickFavorite" />
                                    </div>

                                    <div class="col-xs-12 col-sm-12" v-if="filteredTrails.length == 0">
                                        <q-card>
                                            <q-card-title>
                                                {{ $t('no_trail_found') }}
                                            </q-card-title>
                                            <q-card-separator />
                                            <q-card-main v-if="this.search || this.selected_areas.length > 0 || this.favorite != 'all' || this.progress != 'all' || this.selected_groups.length > 0">
                                                {{ $t('searched_term_returned_no_results') }}
                                            </q-card-main>
                                            <q-card-main v-else>
                                                {{ $t('there_are_no_trails_avaliable_at_the_moment') }}
                                            </q-card-main>
                                        </q-card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>

        <modal-stars :show="show_modal" :trail="trail" @hideModal="hideModal" />
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Filter from 'components/trails/Filter'
import CardDesktop from 'components/trails/CardDesktop'
import CardMobile from 'components/trails/CardMobile'
import ModalStars from 'components/trails/ModalStars'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "trails"] },

    data() {
        return {
            tab: 'trails',
            trails: [],
            trail: [],
            show_modal: false,
            certificate_data: [],
            show_certificate: false,
            banners: [],
        }
    },

    components: {
        'card-trail-desktop': CardDesktop,
        'card-trail-mobile': CardMobile,
        'filter-trail': Filter,
        'modal-stars': ModalStars
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            reload_content: 'common/reload_content',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            search: 'trails/search',
            progress: 'trails/progress',
            favorite: 'trails/favorite',
            selected_areas: 'trails/selected_areas',
            selected_groups: 'trails/selected_groups',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showBanner() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) {
                if(obj.show_banner_mobile) return true
                else return false
            }
            else return true
        },

        getHeight() {
            let height = (220 / 395) * this.$q.screen.width
            return parseInt(height)
        },

		title_trails(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_trails == '' ? 'trails' : obj.title_trails
				}
			}
        },

        filterClass() {
            if (this.$q.platform.is.ipad) return 'col-12'
            else return 'col-xs-12 col-sm-3'
        },

        contentClass() {
            if (this.$q.platform.is.ipad) return 'col-12'
            else return 'col-xs-12 col-sm-9'
        },

        filteredTrails() {
            let filtered = []
            filtered = Object.assign(this.trails, [])

            if (this.search) {
                filtered = filtered.filter((trail) => {
                    return trail.title.toUpperCase().includes(this.search.toUpperCase())
                })
            }

            if (this.selected_areas.length > 0) {
                filtered = filtered.filter((trail) => {
                    let result = this.selected_areas.filter(x => trail.areas.includes(x))
                    return result.length > 0 ? true : false
                })
            }

            if (this.selected_groups.length > 0) {
                filtered = filtered.filter((trail) => {
                    let result = this.selected_groups.filter(x => trail.user_groups.includes(x))
                    return result.length > 0 ? true : false
                })
            }

            if (this.progress != 'all') {
                filtered = filtered.filter((trail) => {
                    if (this.progress == 'in-progress') {
                        return trail.user_trail_progress > 0 && trail.user_trail_progress <  100 ? true : false
                    }
                    else if (this.progress == 'to-do') {
                        return trail.user_trail_progress == 0 ? true : false
                    }
                    else if (this.progress == 'finished') {
                        return trail.user_trail_progress == 100 ? true : false
                    }
                })
            }

            if (this.favorite != 'all') {
                filtered = filtered.filter((trail) => {
                    return trail.favorited
                })
            }
            return filtered
        },
    },

    methods: {
        loadTrails() {
            this.$q.loading.show()
            this.$axios.get('/etraining_trails/trails/', this.getHeader)
            .then(response => {
                response.data.trails.map((trail) => {
                    let image_small = ''
                    let image_thumb = ''

                    let obj = trail.trail_images.find((obj) => { return obj.name === 'thumbnail' })
                    if (obj) image_thumb = obj.image_url

                    obj = trail.trail_images.find((obj) => { return obj.name === 'small' })
                    if (obj) image_small = obj.image_url


                    this.trails.push({
                        areas: trail.areas,
                        image_small: image_small,
                        stars: trail.avg_stars ? parseInt(trail.avg_stars) : 0,
                        stars_rating: trail.avg_stars,
                        starred: trail.starred,
                        description: trail.description,
                        id: trail.id,
                        liked: trail.liked,
                        likes: trail.likes ? trail.likes : "0",
                        profiles: trail.profiles,
                        qty_published_group_trainings: trail.qty_published_group_trainings,
                        qty_user_group_trainings_results: trail.qty_user_group_trainings_results,
                        tags: trail.tags,
                        title: trail.title,
                        user_groups: trail.user_groups,
                        user_trail_progress: trail.user_trail_progress,
                        trail_user_result_status: trail.trail_user_result_status,
                        favorited: trail.favorited,
                        is_blocked: trail.is_blocked,
                        trail_parent: trail.trail_parent,
                        trail_parent_title: trail.trail_parent_title
                    })
                })
                this.$q.loading.hide()
                // if (!response.data.next) this.has_next_page = false
                // else this.page++
            })
            .catch(e => {
                console.log(e)
            })
        },

        fetchAll() {
            this.$axios.all([this.fetchLists(), this.fetchBanners()])
            .then(this.$axios.spread((lists, banners) => {
                this.$store.dispatch('site_lists/SET_LISTS', [lists.data])

                banners.data.map((banner) => {
                    this.banners.push(banner)
                })
            }))
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        fetchLists() {
            return this.$axios.get('/accounts/get_site_registration_lists/', this.getHeader)
        },

        fetchBanners() {
            return this.$axios.get('/etraining_banners/banners/get_banner_by_type/?banner_type=2', this.getHeader)
        },

        clickLike(id) {
            let obj = this.trails.find((obj) => { return obj.id === id })

            if (obj) {
                if (obj.liked) obj.likes--
                else if (!obj.liked) obj.likes++

                obj.liked = !obj.liked
            }

            let fd = new FormData()

            this.$axios.post(`/etraining_trails/trails/${id}/like_trail/`, fd, this.getHeader)
            .then(response => {
                obj.likes = response.data.likes
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        clickFavorite(id) {
            let obj = this.trails.find((obj) => { return obj.id === id })

            if (obj) {
                obj.favorited = !obj.favorited
            }

            let fd = new FormData()

            this.$axios.post(`/etraining_trails/trails/${id}/set_trail_user_favorite/`, fd, this.getHeader)
            .then(response => {
                obj.favorited = response.data.favorited
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        clickStars(id) {
            let obj = this.trails.find((obj) => { return obj.id === id })

            if (obj) {
                this.trail = obj
                this.show_modal = true
            }
        },

        hideModal(type) {
            if (type == 'commented') {
                this.trail.starred = true
            }
            this.show_modal = false
        }
    },

    watch: {
        reload_content: function() {
            this.fetchAll()
            this.loadTrails()
        }
    },

    created() {
        this.fetchAll()
        this.loadTrails()
    }
}
</script>

<style lang="stylus" scoped>
.responsive
    width 100%
    height auto
</style>
